import { Box, Typography } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  getFeatureFlagOutsideReact,
} from '../../../../../../lib/featureFlags';
import { latestSampleSetInterpretiveReportQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/'
)({
  loader: async ({ context, params }) => {
    const latestReport = await context.queryClient.fetchQuery(
      latestSampleSetInterpretiveReportQueryOptions(
        params.sampleSetId,
        context.auth.hasPermission
      )
    );

    if (latestReport) {
      throw redirect({
        to: '/experiments/$sampleSetId/interpretations/$interpretationId',
        params: {
          sampleSetId: params.sampleSetId,
          interpretationId: latestReport.id,
        },
        search: true,
        replace: true,
      });
    }

    if (await getFeatureFlagOutsideReact(FEATURE_FLAGS.studyPreparationChat)) {
      throw redirect({
        to: '/experiments/$sampleSetId/interpretations/new',
        params: { sampleSetId: params.sampleSetId },
        search: true,
        replace: true,
      });
    }
  },
  // Renders only when the user can see no interpretation of the sample set,
  // and the study preparation chat is off
  component: NoInterpretationRoute,
});

function NoInterpretationRoute() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
      }}
    >
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        No interpretations for this sample set yet.
      </Typography>
    </Box>
  );
}
